// Fallback constants — mirrors be-employee's
// src/core/public/external-integration/constants/*. When BE's
// GetTargetFields endpoint succeeds, those values override these.

export const TARGET_FIELDS = [
  'firstName',
  'lastName',
  'gender',
  'dateOfBirth',
  'signOnDate',
  'signOffDate',
  'email',
  'idType',
  'idNo',
  'nationality',
  'designation',
  'phone',
  'departments',
  'crewStatus',
  'metadata',
];

export const SIMPLE_TRANSFORMS = ['lowercase', 'uppercase', 'arrayWrap'];

export const PARAM_TRANSFORMS = [
  'dateFormat',
  'prefix',
  'suffix',
  'concat',
  'booleanMap',
  'constant',
  'default',
];

export const CRON_PRESETS = [
  { label: 'Off (manual only)', value: null },
  { label: 'Every 5 min', value: '*/5 * * * *' },
  { label: 'Every 15 min', value: '*/15 * * * *' },
  { label: 'Every 30 min', value: '*/30 * * * *' },
  { label: 'Hourly', value: '0 * * * *' },
  { label: 'Every 6h', value: '0 */6 * * *' },
  { label: 'Daily', value: '0 0 * * *' },
];

export const ACTIONS = ['IMPORT', 'DISABLE', 'OFF'];

export const DEFAULT_CONFIG = {
  enabled: false,
  source: {
    url: '',
    method: 'POST',
    auth: { type: 'apiKey', headerName: 'x-api-key', secretEnvName: '' },
    filterParamName: 'vesselName',
    extraBody: { fullSync: 'true' },
    responsePath: 'data',
  },
  groups: [],
  mapping: {},
  defaults: {
    employerName: '',
    clinic: { id: '', clientId: '', name: '' },
    emailPrefix: '',
    idType: 'CID',
  },
  schedule: { cron: null },
  notifications: { slackChannel: '', slackBatchSize: 5 },
};
